import DiscourseRoute from "discourse/routes/discourse";
import { i18n } from "discourse-i18n";

export default class CommunityMediaRoute extends DiscourseRoute {
  queryParams = {
    game: { refreshModel: true },
    type: { refreshModel: true },
    sort: { refreshModel: true },
    page: { refreshModel: true },
  };

  model({ game, type = "all", sort = "latest", page = 0 }) {
    return { game, type, sort, page };
  }

  titleToken() {
    return i18n("community_navigation.media_gallery");
  }
}
